export const focusDrawerContent = container => {
  if (!container || container.contains(document.activeElement)) {
    return;
  }

  container.focus({ preventScroll: true });
};
